import { IconButton } from '@mui/material';
import { useDispatch } from 'react-redux';

import {
  Iconify,
  MenuPopover,
  RowActions as MenuRowActions,
  useMenuPopover,
} from '@app/components';
import { Strings } from '@app/constants';
import { useRequestState } from '@app/hooks';
import { selectDeleteListState } from '../selector';
import { deleteListByID } from '../slice';

interface Props {
  setEditing: React.Dispatch<React.SetStateAction<boolean>>;
  listId: string;
}
const RowActions = ({ setEditing, listId }: Props) => {
  const menuPopover = useMenuPopover();
  const dispatch = useDispatch();

  useRequestState({
    stateSelector: selectDeleteListState,
    errorShown: true,
  });

  const actions = [
    {
      label: Strings.rowActions.edit,
      callback: () => {
        setEditing(true);
      },
    },
    {
      label: Strings.rowActions.delete,
      callback: () => {
        dispatch(deleteListByID({ listId }));
      },
    },
  ];

  return (
    <>
      <IconButton onClick={menuPopover.show}>
        <Iconify icon="eva:more-horizontal-fill" />
      </IconButton>

      <MenuPopover
        open={menuPopover.rowMenuAnchorElement}
        arrow="right-top"
        sx={{ width: 180 }}
        onClose={menuPopover.hide}
      >
        <MenuRowActions actions={actions} onClickAction={menuPopover.hide} />
      </MenuPopover>
    </>
  );
};

export { RowActions };
